import DateFnsUtils from '@date-io/date-fns';
import {Trans} from '@lingui/macro';
import {
  Button,
  Grid,
  Paper,
  CircularProgress,
  Box,
  TextField,
  MenuItem,
} from '@material-ui/core';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import PieChartPending from 'components/Graphics/Components/PieChart';
import {useUtilInformation} from 'components/hooks';
import {i18n2} from 'features/i18n/i18n';
import {Form, Formik} from 'formik';
import React, {useState} from 'react';
import KPIGrid from './grids/KPIGrid';
import moment from 'moment';
import {ReportTypes} from 'helpers/report';
import PopupReport from 'components/Popups/PopupReport';
import {MonthlyReport} from 'constants/url';
import getGraphicsMonthly from './requests/monthlyConsult/getGraphicsMonthly';

const MonthlyForm = (props) => {
  const [isConsultReady, setIsConsultReady] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {token} = useUtilInformation();
  const [dataGraphics, setDataGraphics] = useState([]);
  const [filters, setFilters] = useState([]);
  const [openReport, setOpenReport] = useState(false);
  const [reportType, setReportType] = useState(null);
  const [reportValues, setReportValues] = useState(null);

  const buildMonthlyRange = ({year, month, condition, doc_Number}) => {
    const startDate = moment({year, month: month - 1, day: 1})
      .startOf('day')
      .toDate();

    const endDate = moment(startDate).endOf('month').endOf('day').toDate();

    return {
      startDate,
      endDate,
      condition,
      doc_Number,
    };
  };

  const buildKpiFiltersFromRange = ({
    startDate,
    endDate,
    condition,
    doc_Number,
  }) => {
    const filters = [];

    filters.push(['finishedDate', '>=', startDate]);
    filters.push(['finishedDate', '<=', endDate]);

    if (condition === 1) {
      // Pendientes
      filters.push(['status', '<>', 1]);
    }

    if (condition === 2) {
      // Completos
      filters.push(['status', '=', 1]);
    }

    if (doc_Number) {
      filters.push(['doc_Number', 'contains', doc_Number]);
    }

    return filters;
  };

  const handleSubmit = (values, formikBag, isPopup) => {
    const range = buildMonthlyRange(values);

    setFilters(buildKpiFiltersFromRange(range));

    if (isPopup) {
      setReportValues(range);
      setOpenReport(true);
      return;
    }

    setIsLoading(true);
    formikBag.setSubmitting(false);

    getGraphicsMonthly(token, range).then((data) => {
      if (data != null) {
        setIsConsultReady(true);
        setDataGraphics(JSON.parse(data));
      }
      setIsLoading(false);
    });
  };

  return (
    <>
      <Paper style={{margin: 10, marginTop: 0, padding: 10}}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Formik
            initialValues={{
              year: moment().year(),
              month: moment().month() + 1,
              condition: 2,
              doc_Number: '',
            }}
            enableReinitialize
            onSubmit={(values, formikBag) => {
              handleSubmit(values, formikBag, false);
            }}>
            {({errors, touched, ...formikProps}) => {
              return (
                <Form>
                  <Grid container spacing={2}>
                    <Grid item md={4} xs={12}>
                      <TextField
                        select
                        label={i18n2._('Mes')}
                        value={formikProps.values.month}
                        onChange={(e) =>
                          formikProps.setFieldValue(
                            'month',
                            Number(e.target.value),
                          )
                        }
                        fullWidth
                        variant="outlined">
                        {MONTHS.map((m) => (
                          <MenuItem key={m.id} value={m.id}>
                            {m.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <TextField
                        select
                        label={i18n2._('Año')}
                        value={formikProps.values.year}
                        onChange={(e) =>
                          formikProps.setFieldValue(
                            'year',
                            Number(e.target.value),
                          )
                        }
                        fullWidth
                        variant="outlined">
                        {YEARS.map((y) => (
                          <MenuItem key={y.id} value={y.id}>
                            {y.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid item md={4} xs={12}>
                      <TextField
                        select
                        label={i18n2._('Condición')}
                        value={formikProps.values.condition}
                        onChange={(e) =>
                          formikProps.setFieldValue(
                            'condition',
                            Number(e.target.value),
                          )
                        }
                        fullWidth
                        variant="outlined">
                        <MenuItem value={0}>{i18n2._('Todos')}</MenuItem>
                        <MenuItem value={1}>{i18n2._('Pendientes')}</MenuItem>
                        <MenuItem value={2}>{i18n2._('Completos')}</MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <TextField
                        label={i18n2._('Documento')}
                        value={formikProps.values.doc_Number}
                        onChange={(e) =>
                          formikProps.setFieldValue(
                            'doc_Number',
                            e.target.value,
                          )
                        }
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item md={12} xs={12}>
                      <Button
                        type="submit"
                        disabled={formikProps.isSubmitting}
                        variant="contained"
                        color="primary"
                        style={{margin: '5px'}}>
                        <Trans>Visualizar</Trans>
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{margin: '5px'}}
                        onClick={(e) =>
                          formikProps.validateForm().then((errors) => {
                            if (
                              Object.keys(errors).length === 0 &&
                              errors.constructor === Object
                            ) {
                              handleSubmit(
                                formikProps.values,
                                formikProps.formikBag,
                                true,
                              );
                              setReportType(ReportTypes.PDF);
                            }
                          })
                        }>
                        <Trans>Descargar PDF</Trans>
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{margin: '5px'}}
                        onClick={(e) =>
                          formikProps.validateForm().then((errors) => {
                            if (
                              Object.keys(errors).length === 0 &&
                              errors.constructor === Object
                            ) {
                              handleSubmit(
                                formikProps.values,
                                formikProps.formikBag,
                                true,
                              );
                              setReportType(ReportTypes.Excel);
                            }
                          })
                        }>
                        <Trans>Descargar excel</Trans>
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
        </MuiPickersUtilsProvider>
        <PopupReport
          open={openReport}
          setOpen={setOpenReport}
          name="Reporte Mensual"
          url={MonthlyReport}
          pdfOnly={false}
          type={reportType}
          userFilters={reportValues}
          filters={[]}
          isMonthly
        />
      </Paper>
      {isLoading ? (
        <Grid
          container
          alignContent="center"
          alignItems="center"
          justify="center">
          <Box style={{margin: 50, padding: 50}}>
            <CircularProgress />
          </Box>
        </Grid>
      ) : isConsultReady ? (
        <>
          <Grid
            container
            spacing={2}
            alignContent="center"
            alignItems="center"
            justify="center">
            {dataGraphics.map((x, i) => {
              return (
                <Grid item sm={3}>
                  <Paper style={{margin: 10, padding: 10}}>
                    <PieChartPending
                      key={i}
                      title={x.title}
                      data={x.data}
                      userName={x.value}
                      argumentField="title"
                      valueField="value"
                      group="test"
                      width={'50%'}
                      height={290}
                    />
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
          <Paper style={{margin: 10, padding: 10}}>
            <KPIGrid filters={filters} />
          </Paper>
        </>
      ) : null}
    </>
  );
};

export default MonthlyForm;

const MONTHS = [
  {id: 1, label: 'Enero'},
  {id: 2, label: 'Febrero'},
  {id: 3, label: 'Marzo'},
  {id: 4, label: 'Abril'},
  {id: 5, label: 'Mayo'},
  {id: 6, label: 'Junio'},
  {id: 7, label: 'Julio'},
  {id: 8, label: 'Agosto'},
  {id: 9, label: 'Septiembre'},
  {id: 10, label: 'Octubre'},
  {id: 11, label: 'Noviembre'},
  {id: 12, label: 'Diciembre'},
];

const YEARS = Array.from({length: 5}, (_, i) => {
  const year = moment().year() - i;
  return {id: year, label: year};
});
